import ToolShell, { OutputBlock, HookRow } from "@/pages/tools/ToolShell";

export default function CreateReel() {
  return (
    <ToolShell
      testid="tool-reel-page"
      eyebrow="Tool" toolKey="reel"
      title="Create New Reel"
      subtitle="Brief us in plain English. We engineer the rest - hook, structure, caption, CTA, pinned comment."
      endpoint="/tools/reel"
      fields={[
        { key: "topic", label: "What is this reel about?", type: "textarea", rows: 3, required: true, placeholder: "e.g. Why most divers' trim looks awful on camera and how to fix it in one dive." },
        { key: "footage_description", label: "Describe your footage (optional)", type: "textarea", rows: 3, placeholder: "e.g. 20s clip of me hovering motionless next to a coral head, mask off, slow exhale." },
        { key: "hook_idea", label: "Have a hook in mind? (optional)", type: "text", placeholder: "e.g. Stop blaming your tank size" },
        { key: "caption", label: "Paste an existing caption draft (optional)", type: "textarea", rows: 3 },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-concept" label="Reel Concept" copyValue={o.reel_concept}>{o.reel_concept}</OutputBlock>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <OutputBlock testid="output-archetype" label="Hook Archetype">{o.hook_archetype}</OutputBlock>
            <OutputBlock testid="output-trigger" label="Psychological Trigger">{o.psychological_trigger}</OutputBlock>
          </div>
          <OutputBlock testid="output-hooks" label="3 Hook Options" copyValue={(o.hooks || []).join("\n")}>
            {(o.hooks || []).map((h, i) => <HookRow key={i} hook={h} />)}
          </OutputBlock>
          {o.structure && (
            <OutputBlock testid="output-structure" label="Structure Recommendation">
              <div className="space-y-3 text-[14.5px]">
                {o.structure.visual_hook && <div><span className="dms-label">Visual Hook</span><div className="mt-1">{o.structure.visual_hook}</div></div>}
                {o.structure.shot_guidance && <div><span className="dms-label">Shot Guidance</span><div className="mt-1">{o.structure.shot_guidance}</div></div>}
                {o.structure.edit_timing && <div><span className="dms-label">Edit Timing</span><div className="mt-1">{o.structure.edit_timing}</div></div>}
                {o.structure.audio_guidance && <div><span className="dms-label">Audio</span><div className="mt-1">{o.structure.audio_guidance}</div></div>}
              </div>
            </OutputBlock>
          )}
          <OutputBlock testid="output-caption" label={`Full Caption (${(o.caption || "").length} chars)`} copyValue={o.caption}>
            <div className="whitespace-pre-wrap leading-relaxed">{o.caption}</div>
          </OutputBlock>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <OutputBlock testid="output-cta" label="CTA" copyValue={o.cta}>{o.cta}</OutputBlock>
            <OutputBlock testid="output-pinned" label="Pinned Comment" copyValue={o.pinned_comment}>{o.pinned_comment}</OutputBlock>
          </div>
        </>
      )}
    />
  );
}
